export const Tasks_Mdm_Demo = [
  {
    "ID": "2949481",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "1.05.2020",
    "DateExecuted": "21.05.2020 14:18:23",
    "DateStarted": "21.05.2020 14:15:56",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Импорт данных. Подписка SRV-002",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2949344",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "18.05.2020",
    "DateExecuted": "21.05.2020 19:10:15",
    "DateStarted": "21.05.2020 19:08:43",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Проверка и обогащение данных. Подписка SRV-003",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "21.05.2020 11:08:12",
    "DateStarted": "21.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Проверка и обогащение данных. Подписка SRV-004",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "20.05.2020 11:08:12",
    "DateStarted": "20.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Экспорт мастер-данных в систему отчетности. Партнер 56743",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2949481",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "17.05.2020",
    "DateExecuted": "20.05.2020 14:18:23",
    "DateStarted": "20.05.2020 14:15:56",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Импорт данных. Подписка SRV-002",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2949344",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "18.05.2020",
    "DateExecuted": "20.05.2020 19:10:15",
    "DateStarted": "20.05.2020 19:08:43",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Проверка и обогащение данных. Подписка SRV-003",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "19.05.2020 11:08:12",
    "DateStarted": "19.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Проверка и обогащение данных. Подписка SRV-004",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "19.05.2020 11:08:12",
    "DateStarted": "19.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Экспорт мастер-данных в систему отчетности. Партнер 56743",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2949481",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "17.05.2020",
    "DateExecuted": "18.05.2020 14:18:23",
    "DateStarted": "18.05.2020 14:15:56",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Импорт данных. Подписка SRV-002",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2949344",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "18.05.2020",
    "DateExecuted": "18.05.2020 19:10:15",
    "DateStarted": "18.05.2020 19:08:43",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Проверка и обогащение данных. Подписка SRV-003",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "18.05.2020 11:08:12",
    "DateStarted": "18.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Проверка и обогащение данных. Подписка SRV-004",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "17.05.2020 11:08:12",
    "DateStarted": "17.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Экспорт мастер-данных в систему отчетности. Партнер 56743",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2949481",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "17.05.2020",
    "DateExecuted": "17.05.2020 14:18:23",
    "DateStarted": "17.05.2020 14:15:56",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Импорт данных. Подписка SRV-002",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2949344",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "18.05.2020",
    "DateExecuted": "16.05.2020 19:10:15",
    "DateStarted": "16.05.2020 19:08:43",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Проверка и обогащение данных. Подписка SRV-003",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "16.05.2020 11:08:12",
    "DateStarted": "16.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Проверка и обогащение данных. Подписка SRV-004",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "16.05.2020 11:08:12",
    "DateStarted": "16.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Экспорт мастер-данных в систему отчетности. Партнер 56743",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
];
export const Tasks_Mdm_Demo_rd = [
  {
    "ID": "2949481",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "1.05.2020",
    "DateExecuted": "21.05.2020 14:18:23",
    "DateStarted": "21.05.2020 14:15:56",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Проверка и обогащение данных. Подписка SRV-003",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2949344",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "18.05.2020",
    "DateExecuted": "21.05.2020 19:10:15",
    "DateStarted": "21.05.2020 19:08:43",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Проверка и обогащение данных. Подписка SRV-003",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "21.05.2020 11:08:12",
    "DateStarted": "21.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Публикация обновлений мастер-данных сайтов. Подписка SRV-005",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2932547",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "19.05.2020",
    "DateExecuted": "20.05.2020 11:08:12",
    "DateStarted": "20.05.2020 11:06:47",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200519",
    "OprName": "Экспорт данных по сайтам  в мастер-систему ритейлера",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Единоразовый",
    "URL": "HTTP://10.147.170.98/PUBLICREPORTS/RANG_LUNAR_VANZARI_2932547.XLSX"
  },
  {
    "ID": "2949481",
    "Phase": "3",
    "Status": "0",
    "UserId": "17209696",
    "DateSubmited": "17.05.2020",
    "DateExecuted": "20.05.2020 14:18:23",
    "DateStarted": "20.05.2020 14:15:56",
    "EndCode": "0",
    "OprCode": "SITE_IMPORT",
    "OprParams": "DATE: 20200518",
    "OprName": "Публикация обновлений мастер-данных сайтов. Подписка SRV-005",
    "UserLogin": "GLK",
    "profile": null,
    "ScheduleType": "Single execution",
    "URL": "http://10.147.170.141/PublicReports/"
  }
];

